export const snackbar = {
    addToCartSuccess: "Cart has been updated.",
};
